import { isBrowser } from "../../../common/helpers/env";
import React, { useEffect } from "react";

import { adsenseClientId } from "../../../common/parameters";

import { adsenseSlots } from "./slots";
import { IProps } from "./interfaces";

const isServer = !isBrowser;
const isTesting = isServer || window.location.host !== "musicators.com";

const isAdsEnabled = !isServer && window.isAdsEnabled === 1;

const AdSense = ({ height, width, slot }: IProps) => {
    const returnNull = isServer || !isAdsEnabled;
    useEffect(() => {
        if (returnNull) return;
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    if (returnNull) return null;

    return (
        <ins
            className="adsbygoogle"
            style={{
                display: "block",
                height,
                width,
                ...(isTesting && {
                    boxShadow: "0 0 3px 0 rgba(0, 0, 0, 0.3)",
                    backgroundColor: "#EEEEEE",
                }),
            }}
            data-ad-client={adsenseClientId}
            data-ad-slot={adsenseSlots[slot]}
            data-full-width-responsive="true"
            {...((isTesting || !isAdsEnabled) && { "data-ad-test": "on" })}
        />
    );
}

export default AdSense;
